import { Divider, Group, Title } from "@mantine/core";

const MobileFilterTitle = () => (
  <div className="w-full">
    <Group position="apart">
      <Title order={3} p={10}>
        Filteren op vakantiehuis
      </Title>
    </Group>
    <Divider />
  </div>
);

export default MobileFilterTitle;
